<template>
    <div class="flex gap-8">
        <gc-button
            secondary
            :label="declineAccessLinkLabel"
            :url="declineAccessLink"
            @click.prevent="handleClick($event, false)" />
        <gc-button
            color="primary"
            :label="approveAccessLinkLabel"
            :url="approveAccessLink"
            @click.prevent="handleClick($event, true)" />
    </div>
</template>

<script lang="ts">
import GcButton from '../base/GcButton.vue';
import Cookies from 'js-cookie';

export default {
    components: { GcButton },
    props: {
        cookieName: { type: String },
        approveAccessLink: { type: String },
        approveAccessLinkLabel: { type: String },
        declineAccessLink: { type: String },
        declineAccessLinkLabel: { type: String },
    },
    methods: {
        handleClick(event: any, accept: boolean) {
            Cookies.set(this.cookieName, String(accept));
            window.location.assign(event.currentTarget.href);
        },
    },
};
</script>
